;(function () {
  const STEP_DELAY = 150
  const FADE_DURATION = 150
  const COLLAPSE_DURATION = 400
  const INITIAL_HOLD = 300

  // Aggiunge questa costante alle altre già esistenti
  const LOOP_PAUSE = 1200 // ms di pausa prima di invertire

  function runAnimation(el) {
    const original = el.textContent.trim()
    const len = original.length
    if (len < 2) return

    const toReverse = original.slice(0, len - 1)
    const mirror = toReverse.split('').reverse().join('')
    const steps = len - 1

    el.textContent = ''
    el.style.whiteSpace = 'nowrap'

    const dimWrap = document.createElement('span')
    dimWrap.style.cssText =
      'display:inline-block; overflow:hidden; white-space:nowrap; vertical-align:top; transition:width ' +
      COLLAPSE_DURATION +
      'ms ease'

    const stayWrap = document.createElement('span')
    stayWrap.style.cssText =
      'display:inline-block; white-space:nowrap; vertical-align:top'

    const dimSpans = toReverse.split('').map((char) => {
      const s = document.createElement('span')
      s.textContent = char
      s.style.transition = 'opacity ' + FADE_DURATION + 'ms'
      if (char === ' ') s.style.whiteSpace = 'pre'
      dimWrap.appendChild(s)
      return s
    })

    const lastSpan = document.createElement('span')
    lastSpan.textContent = original[len - 1]
    stayWrap.appendChild(lastSpan)

    const mirrorSpans = mirror.split('').map((char) => {
      const s = document.createElement('span')
      s.textContent = char
      s.style.opacity = '0'
      s.style.display = 'inline-block'
      if (char === ' ') s.style.whiteSpace = 'pre'
      stayWrap.appendChild(s)
      return s
    })

    el.appendChild(dimWrap)
    el.appendChild(stayWrap)

    requestAnimationFrame(() => {
      const fullWidth = dimWrap.offsetWidth
      dimWrap.style.width = fullWidth + 'px'

      // ── FORWARD ──────────────────────────────────────────────
      const doForwardStep = (step) => {
        if (step >= steps) {
          setTimeout(() => {
            dimSpans.forEach((s) => (s.style.opacity = '0'))
            dimWrap.style.width = '0'
            // Pausa, poi avvia il reverse
            setTimeout(startReverse, COLLAPSE_DURATION + LOOP_PAUSE)
          }, STEP_DELAY)
          return
        }

        const dimIdx = steps - 1 - step
        const dimSpan = dimSpans[dimIdx]
        const mirrorSpan = mirrorSpans[step]

        dimSpan.style.opacity = '0.5'

        const dimRect = dimSpan.getBoundingClientRect()
        const mirrorRect = mirrorSpan.getBoundingClientRect()
        const offsetX = dimRect.left - mirrorRect.left

        mirrorSpan.style.transition = 'none'
        mirrorSpan.style.transform = `translateX(${offsetX}px)`
        mirrorSpan.getBoundingClientRect()

        mirrorSpan.style.transition =
          'opacity ' +
          FADE_DURATION +
          'ms, transform ' +
          FADE_DURATION +
          'ms ease'
        mirrorSpan.style.opacity = '1'
        mirrorSpan.style.transform = 'translateX(0)'

        setTimeout(() => doForwardStep(step + 1), STEP_DELAY)
      }

      // ── REVERSE ───────────────────────────────────────────────
      const startReverse = () => {
        // Riespande il dimWrap (i dimSpans sono ancora opacity 0)
        dimWrap.style.width = fullWidth + 'px'
        setTimeout(() => doReverseStep(steps - 1), COLLAPSE_DURATION)
      }

      const doReverseStep = (step) => {
        if (step < 0) {
          // Reset mirrorSpans per il prossimo ciclo
          mirrorSpans.forEach((s) => {
            s.style.transition = 'none'
            s.style.transform = 'translateX(0)'
            s.style.opacity = '0'
          })
          // Pausa, poi riparte in avanti
          setTimeout(() => doForwardStep(0), LOOP_PAUSE)
          return
        }

        const dimIdx = steps - 1 - step
        const dimSpan = dimSpans[dimIdx]
        const mirrorSpan = mirrorSpans[step]

        // mirrorSpan scivola verso la posizione del dimSpan e svanisce
        const dimRect = dimSpan.getBoundingClientRect()
        const mirrorRect = mirrorSpan.getBoundingClientRect()
        const offsetX = dimRect.left - mirrorRect.left

        mirrorSpan.style.transition =
          'opacity ' +
          FADE_DURATION +
          'ms, transform ' +
          FADE_DURATION +
          'ms ease'
        mirrorSpan.style.opacity = '0'
        mirrorSpan.style.transform = `translateX(${offsetX}px)`

        // dimSpan riappare
        dimSpan.style.transition = 'opacity ' + FADE_DURATION + 'ms'
        dimSpan.style.opacity = '1'

        setTimeout(() => doReverseStep(step - 1), STEP_DELAY)
      }

      setTimeout(() => doForwardStep(0), INITIAL_HOLD)
    })
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target)
          runAnimation(entry.target)
        }
      })
    },
    { threshold: 0.5 }
  )

  document
    .querySelectorAll('.shuffle-text-animation')
    .forEach((el) => observer.observe(el))
})()
